import development from './development';
import { ENV } from './env';
import production from './production';

type Config = typeof production | typeof development;

const getConfigOverride = (): Partial<Config> => {
  const override = JSON.parse(
    localStorage.getItem('configOverride') ?? '{}',
  ) as Partial<Config>;
  return override;
};

const saveConfigOverride = (config: Partial<Config>) => {
  localStorage.setItem('configOverride', JSON.stringify(config));
};

const clearConfigOverride = () => {
  localStorage.removeItem('configOverride');
};

const getConfig = (): Config => {
  // return prod config without any overrides
  if (ENV.VITE_APPLICATION_ENV === 'production') {
    return production;
  }
  // otherwise apply overrides to dev config
  const config = development;
  const override = typeof window !== 'undefined' ? getConfigOverride() : {};
  return { ...config, ...override };
};

export const config = getConfig();
